import React, { Component } from 'react';
import * as FieldInventoryAction from '../actions/FieldInventoryWorkBenchAction';
import FieldInventoryStore from '../stores/FieldInventoryWorkBenchStore';
import * as $ from 'jquery';
import * as CookieService from '../CookieService';
import swal from 'sweetalert';
import SDIConstants from '../SDIConstants';
import * as App from '../App';
import { withTranslation } from 'react-i18next';
import ReactPaginate from 'react-paginate';
import Select from 'react-select';
import * as MenuAction from '../actions/MenuAction';
let currentPagePath;




class FieldInventoryComponent extends Component {


    constructor(props) {
        super(props);
        this.PageLoad = this.PageLoad.bind(this);
        this.PageLoadResponse = this.PageLoadResponse.bind(this);
        this.GetData = this.GetData.bind(this);
        this.GetDataResponse = this.GetDataResponse.bind(this);
        //this.GetMoreDetail = this.GetMoreDetail.bind(this);
        //this.GetMoreDetailResponse = this.GetMoreDetailResponse.bind(this);

        /**
    * EPO_PC_03
    * intilize the variable used in this component
    * */
        this.state = {
            PageLoadData: CookieService.getLocalStorageValues('FieldInventory_PageLoadData') || [],
            RegionDD: CookieService.getLocalStorageValues('FieldInventory_RegionDD') || [],
            SubRegionDD: CookieService.getLocalStorageValues("FieldInventory_SubRegionDD") || [],
            TruckidDD: CookieService.getLocalStorageValues("FieldInventory_TruckidDD") || [],
            TechNameDD: CookieService.getLocalStorageValues("FieldInventory_TechNameDD") || [],
            RegionValue: CookieService.getLocalStorageValues("FieldInventory_RegionValue") || '',
            SubRegionValue: CookieService.getLocalStorageValues("FieldInventory_SubRegionValue") || '',
            TruckidValue: CookieService.getLocalStorageValues("FieldInventory_TruckidValue") || '',
            TechNameValue: CookieService.getLocalStorageValues("FieldInventory_TechNameValue") || '',
            GetMoreDetail: [],
            ClearButtonDisable: true,
            ResultCount: 0,
            SearchTxt: CookieService.getLocalStorageValues("FieldInventory_SearchTxt") || '',
            GetData: [],
            PageNo: 1,
            totalCount: 0,
            RecCount: 10,
            PageCount: 0,
            UserId: CookieService.getLocalStorageValues("FieldInventory_UserId"),
            norecordshow: false,
            includeZeroQty: CookieService.getLocalStorageValues("FieldInventory_IncludeZeroCheck") ? CookieService.getLocalStorageValues("FieldInventory_IncludeZeroCheck") : false,
            expandedDescriptions: {}, selectedTruckId: "", selectAll: CookieService.getLocalStorageValues("FieldInventory_TruckidValue") && CookieService.getLocalStorageValues("FieldInventory_TruckidValue").value ? true : false,
        }
    }

    componentWillUnmount() {
        FieldInventoryStore.removeListener('PageLoad', this.PageLoadResponse.bind(this));
        FieldInventoryStore.removeListener('GetData', this.GetDataResponse.bind(this));
        FieldInventoryStore.removeListener('GetMoreDetail', this.GetMoreDetailResponse.bind(this));
        FieldInventoryStore.removeListener('favpage', this.loadFavPageResponse.bind(this));
        FieldInventoryStore.removeListener('updateFavPage', this.updateFavPageResponse.bind(this));

        if ($('#footer-comp').hasClass('fixed-bottom')) {
            $('#footer-comp').removeClass('fixed-bottom');
        }

    }
    /**
     * EPO_PC_04
     * */
    componentDidMount() {
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        FieldInventoryAction.getCurrentFavPage(getFavPageBO);
        if (CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == null || CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == undefined ||
            CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == "" || CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == " " ||
            CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT").toUpperCase() != "0W0T") {
            if (CookieService.getLocalStorageValues("HideMobility") && CookieService.getLocalStorageValues("HideMobility").toUpperCase() == "TRUE") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "This page is exclusively for Truckstock. Please contact your admin/manager to set up the truck crib"
                });
                this.props.history.push({
                    pathname: `/homepage`
                });
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "This page is exclusively for Truckstock. Please select truck crib from user profile to proceed"
                });
                this.props.history.push({
                    pathname: `/profile`,
                    state: { origin: 'Inventory' }
                });
            }
            return;
        }
        let a = CookieService.getLocalStorageValues("FieldInventory_RegionValue");
        if (this.state.RegionValue && this.state.SubRegionValue) {
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            let GetDataBO = {
                Region: this.state.RegionValue.value,
                Sub_Region: this.state.SubRegionValue.value,
                TruckId: this.state.TruckidValue.value,
                TechName: this.state.TechNameValue.value,
                SearchTxt: this.state.SearchTxt,
                Location: CookieService.getLocalStorageValues("Session_STATE") != undefined && CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "",
                ShipToID: CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") !== "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ",
                UserId: this.state.UserId ? this.state.UserId.value : '',
                Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                FromWeb: true,
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID") == "" || undefined || null ? "" : CookieService.getLocalStorageValues("Session_UserID"),

            }
            FieldInventoryAction.GetData(GetDataBO);

            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        } else {
            this.PageLoad();

        }
        FieldInventoryStore.on('PageLoad', this.PageLoadResponse);
        FieldInventoryStore.on('GetData', this.GetDataResponse);
        FieldInventoryStore.on('GetMoreDetail', this.GetMoreDetailResponse);
        FieldInventoryStore.on('favpage', this.loadFavPageResponse.bind(this));
        FieldInventoryStore.on('updateFavPage', this.updateFavPageResponse.bind(this));
    }





    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(FieldInventoryStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };

    updateFavPageResponse = () => {
        if (FieldInventoryStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(FieldInventoryStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(FieldInventoryStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
    };

    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Field Inventory Workbench",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            FieldInventoryAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            FieldInventoryAction.deleteFavPage(deleteFavPageBO)
        }
    };


    PageLoad = () => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let pageLoadBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID") == "" || undefined || null ? "" : CookieService.getLocalStorageValues("Session_UserID"),
        }
        FieldInventoryAction.PageLoad(pageLoadBO);
    }



    PageLoadResponse = () => {
        const pageLoadData = JSON.parse(FieldInventoryStore.PageLoad);
        CookieService.updateLocalStorageValues("FieldInventory_cleardata", false);

        // Check for technical issues
        if (pageLoadData === "Technical issue") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Technical Issue."
            });
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            return;
        }
        if (pageLoadData) {
            // Get the user region and subregion from the first table's first row
            let regiondata = pageLoadData.UserRegion[0];
            let userRegion = regiondata && regiondata.USER_REGION ? { value: regiondata.USER_REGION, label: regiondata.USER_REGION } : { value: "", label: "Select..." };
            let userSubRegion = regiondata && regiondata.USER_SUBREGION ? { value: regiondata.USER_SUBREGION, label: regiondata.USER_SUBREGION } : { value: "", label: "Select..." };
            let fullData = pageLoadData.PageLoad;
            let selectall = [];
            let SubRegionDD = [];
            let TechNameDD = [];
            let TruckidDD = [];

            // Convert backend response to usable data
            let regions = fullData.map(row => ({
                value: row.REGION,
                label: row.REGION,
            }));

            // Error likely due to region key, correcting it
            let subRegions = fullData.map(row => ({
                value: row.SUB_REGION,
                label: row.SUB_REGION,
            }));

            let trucks = fullData.map(row => ({
                value: row.ISA_TRUCK_ID,
                label: row.ISA_TRUCK_ID,
            }));

            let technicians = fullData.map(row => ({
                value: row.ISA_USER_NAME,
                label: row.ISA_USER_NAME,
            }));

            // Create unique list of regions and add "Select All"
            let RegionDD = [...regions];

            fullData.forEach(item => {
                RegionDD = RegionDD.filter((value, index, self) =>
                    index === self.findIndex((t) => (
                        t.value === value.value
                    ))
                );
                if (item.REGION == userRegion.value && !SubRegionDD.some(sub => sub.value === item.SUB_REGION)) {
                    let obj = { value: item.SUB_REGION, label: item.SUB_REGION };
                    SubRegionDD.push(obj);
                }

                if (item.REGION === userRegion.value && item.SUB_REGION === userSubRegion.value && !TechNameDD.some(tech => tech.value === item.ISA_USER_NAME)) {
                    let Tech = item.ISA_USER_NAME.replace(',', ', ');
                    let obj = { value: item.ISA_USER_NAME, label: Tech };
                    TechNameDD.push(obj);
                }

                if (item.REGION === userRegion.value && item.SUB_REGION === userSubRegion.value && !TruckidDD.some(truck => truck.value === item.ISA_TRUCK_ID)) {
                    let Truck = item.ISA_TRUCK_ID;
                    let obj = { value: item.ISA_TRUCK_ID, label: item.TRUCK_ID_DESCR };
                    TruckidDD.push(obj);
                }
            })

            TechNameDD = TechNameDD.sort((a, b) => a.label.localeCompare(b.label));
            TruckidDD = TruckidDD.sort((a, b) => a.label.localeCompare(b.label));

            let defaultvalue = { value: "", label: "Select All" };
            selectall.push(defaultvalue)

            TechNameDD = [...selectall, ...TechNameDD];
            TruckidDD = [...selectall, ...TruckidDD];
            TechNameDD = TechNameDD.filter((ele, ind) => ind === TechNameDD.findIndex(elem => elem.value === ele.value && elem.label === ele.label));
            SubRegionDD = SubRegionDD.filter((ele, ind) => ind === SubRegionDD.findIndex(elem => elem.value === ele.value && elem.label === ele.label));
            TruckidDD = TruckidDD.filter((ele, ind) => ind === TruckidDD.findIndex(elem => elem.value === ele.value && elem.label === ele.label));


            this.setState({
                PageLoadData: fullData,
                RegionDD,
                SubRegionDD,
                TruckidDD,
                TechNameDD,
                RegionValue: userRegion,
                SubRegionValue: userSubRegion,
                TruckidValue: TruckidDD.length > 0 ? { value: TruckidDD[0].value, label: TruckidDD[0].label } : null,
                TechNameValue: TechNameDD.length > 0 ? { value: TechNameDD[0].value, label: TechNameDD[0].label } : null,
            });
        }

        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }



    HandleChangeDD = (selectedOption, type) => {
        const selectAllOption = { value: "", label: "Select All" };
        let subRegionDD = [];
        let techNameDD = [];
        let truckidDD = [];
        let trucklabel = "";

        switch (type) {
            case "Region":

                const regionValue = selectedOption.value;

                this.state.PageLoadData.forEach(item => {
                    if (item.REGION === regionValue) {
                        if (!subRegionDD.find(subRegion => subRegion.value === item.SUB_REGION)) {
                            subRegionDD.push({ value: item.SUB_REGION, label: item.SUB_REGION });
                        }
                        if (!techNameDD.find(tech => tech.value === item.ISA_USER_NAME)) {
                            let techNameLabel = item.ISA_USER_NAME.replace(',', ', ');
                            techNameDD.push({ value: item.ISA_USER_NAME, label: techNameLabel });
                        }
                        if (!truckidDD.find(truck => truck.value === item.ISA_TRUCK_ID)) {
                            truckidDD.push({ value: item.ISA_TRUCK_ID, label: item.TRUCK_ID_DESCR });
                        }
                    }
                });

                truckidDD = truckidDD.sort((a, b) => a.label.localeCompare(b.label));

                this.setState({
                    RegionValue: { value: regionValue, label: regionValue },
                    SubRegionDD: [...subRegionDD],
                    TechNameDD: [selectAllOption, ...techNameDD],
                    TruckidDD: [selectAllOption, ...truckidDD],
                    SubRegionValue: '',
                    TechNameValue: '',
                    TruckidValue: '',
                    GridData: []
                });
                break;

            case "Subregion":
                techNameDD = [];
                truckidDD = [];

                const subRegionValue = selectedOption.value;

                this.state.PageLoadData.forEach(item => {
                    if (item.SUB_REGION === subRegionValue) {
                        if (!truckidDD.find(truck => truck.value === item.ISA_TRUCK_ID)) {
                            truckidDD.push({ value: item.ISA_TRUCK_ID, label: item.TRUCK_ID_DESCR });
                        }
                        if (!techNameDD.find(tech => tech.value === item.ISA_USER_NAME)) {
                            let techNameLabel = item.ISA_USER_NAME.replace(',', ', ');
                            techNameDD.push({ value: item.ISA_USER_NAME, label: techNameLabel });
                        }
                    }
                });
                truckidDD = truckidDD.sort((a, b) => a.label.localeCompare(b.label));

                this.setState({
                    SubRegionValue: { value: subRegionValue, label: subRegionValue },
                    TruckidDD: [selectAllOption, ...truckidDD],
                    TechNameDD: [selectAllOption, ...techNameDD],
                    TruckidValue: '',
                    TechNameValue: '',
                    GridData: []
                });
                break;

            case "TruckID":
                techNameDD = [];

                const truckidValue = selectedOption.value;

                this.state.PageLoadData.forEach(item => {
                    if (item.ISA_TRUCK_ID === truckidValue) {
                        if (!techNameDD.find(tech => tech.value === item.ISA_USER_NAME)) {
                            let techNameLabel = item.ISA_USER_NAME.replace(',', ', ');
                            techNameDD.push({ value: item.ISA_USER_NAME, label: techNameLabel });
                            trucklabel = item.TRUCK_ID_DESCR;
                        }
                    }
                });

                this.setState({
                    TruckidValue: {
                        value: truckidValue,
                        label: truckidValue !== "" ? trucklabel : "Select All"
                    },
                    TechNameDD: [selectAllOption, ...techNameDD],
                    TechNameValue: '',
                    GridData: []
                });
                break;

            case "Tech":
                const techNameValue = selectedOption.value;

                // Find the corresponding UserId for the selected TechName
                let userId = "";
                this.state.PageLoadData.forEach(item => {
                    if (item.ISA_USER_NAME === techNameValue) {
                        userId = item.ISA_EMPLOYEE_ID; // Assuming this is the correct key for UserId
                    }
                });

                this.setState({
                    TechNameValue: { value: techNameValue, label: techNameValue === "" ? "Select All" : techNameValue },
                    UserId: { value: userId, label: userId }, // Set the UserId in the state
                    GridData: [] // Reset GridData as per your requirements
                });
                break;

            case "Search":
                const searchTxt = selectedOption.target.value.trim();
                this.setState({
                    SearchTxt: searchTxt,
                    GridData: []
                });
                break;

            default:
                break;
        }
    }
    Searchclear = () => {
        this.setState({ SearchTxt: "" });

    }

    GetData = () => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let GetDataBO = {
            Region: this.state.RegionValue.value,
            Sub_Region: this.state.SubRegionValue.value,
            TruckId: this.state.TruckidValue.value ? this.state.TruckidValue.value : "",
            TechName: this.state.TechNameValue.value,
            SearchTxt: this.state.SearchTxt,
            Location: CookieService.getLocalStorageValues("Session_STATE") != undefined && CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "",
            ShipToID: CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") !== "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ",
            UserId: this.state.TechNameValue.value ? this.state.UserId.value : "",
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
            FromWeb: true,
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID") == "" || undefined || null ? "" : CookieService.getLocalStorageValues("Session_UserID"),
        }
        if ($('#footer-comp').hasClass('fixed-bottom')) {
            $('#footer-comp').removeClass('fixed-bottom');
        }
        this.setState({ norecordshow: true, PageNo: 1, selectAll: this.state.TruckidValue.value ? true : false })
        FieldInventoryAction.GetData(GetDataBO);

    }

    GetDataResponse = () => {
        let GetData = JSON.parse(FieldInventoryStore.GetData);
        let processedData = GetData
        let { totalCount, includeZeroQty } = this.state;
        let pageCount = 0;
        let response_data = [];
        if (!includeZeroQty) {
            response_data = processedData.filter(item => item.actual_qty !== '0');
            totalCount = response_data.length;
            pageCount = Math.ceil(totalCount / 10);
        } else {
            totalCount = processedData.length;
            pageCount = Math.ceil(totalCount / 10);
        }

        this.setState({
            gridData: processedData,
            totalCount,
            pageCount
        });

        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    handleCheckboxChange = (val) => {
        let updatedGridData = [...this.state.gridData];
        let truckId = "";
        if (val && val !== "Unselect All" && val !== "Select All") {
            updatedGridData = updatedGridData.map(item => {
                if (item.inv_item_id === val.inv_item_id && item.isa_truck_id === val.isa_truck_id) {
                    return { ...item, checked: !item.checked }; // Toggle checked state
                }
                return item; // Return unchanged item
            });
        } else {
            // If no specific value is provided, toggle all items
            let allSelected = updatedGridData.every(item => item.checked); // Check if all are selected
            updatedGridData = updatedGridData.map(item => {
                if (item.actual_qty !== '0') {
                    if (val === "Unselect All") {
                        return { ...item, checked: false };
                    } else if (val === "Select All") {
                        return { ...item, checked: true };
                    }

                }
                return item;
            });
        }

        let anyChecked = updatedGridData.some(item => item.checked);
        if (anyChecked) {
            $('#footer-comp').addClass('fixed-bottom');
            truckId = val && val.isa_truck_id ? val.isa_truck_id : val === "Select All" ? updatedGridData[0].isa_truck_id : "";
            $("#cookie-panel").hide();
        }
        else {
            $('#footer-comp').removeClass('fixed-bottom');
        }
        this.setState({
            gridData: updatedGridData,
            selectedTruckId: truckId,
        });
    };
    bindSearchResults = () => {
        let response_data = this.state.gridData;
        const { PageNo, includeZeroQty } = this.state;

        if (!includeZeroQty) {
            response_data = response_data.filter(item => item.actual_qty !== '0');
        }

        if (response_data && response_data.length > 0) {
            const startIndex = (PageNo - 1) * 10;
            const endIndex = startIndex + 10;
            const paginatedData = response_data.slice(startIndex, endIndex);

            return paginatedData.map((val, index) => {
                const isExpanded = this.state.expandedDescriptions[val.inv_item_id] || false;
                const descriptionToShow = !isExpanded && val.long_desc.length > 24 ? `${val.long_desc.substring(0, 24)}...` : val.long_desc; // Truncate if not expanded
                const truckDesc = this.state.PageLoadData.filter(truckFil => truckFil.ISA_TRUCK_ID == val.isa_truck_id).map(truckMap => truckMap.TRUCK_ID_DESCR)[0];
                return (
                    <div className="product-details-container p-3 my-1" key={index}>
                        <div className="row px-3">
                            <div className="col-md-12">
                                <input
                                    type="checkbox"
                                    className="form-check-input position-unset cursor-pointer"
                                    style={{ marginTop: '4.3rem', marginLeft: '-1.25rem', width: '15px', height: '15px' }}
                                    checked={val.checked || false}
                                    onChange={() => this.handleCheckboxChange(val)}
                                    disabled={val.actual_qty === "0" ? true : this.state.selectedTruckId ? val.isa_truck_id !== this.state.selectedTruckId : false}
                                />
                                <div className="row align-items-center">
                                    <div className="col-lg-2 col-md-4 px-lg-0 mb-md-0 mb-3 fieldimageleft" >
                                        <div className="product-img d-flex justify-content-center" >
                                            <img
                                                src={val.image_list || "images/product-image.svg"}
                                                onError={(e) => { e.target.src = "images/noimage_new.png"; }}
                                                alt="product-img"
                                                className=""
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-10 col-md-6">
                                        <div className="row">
                                            <div className="col-lg-4 col-md-12">
                                                <div className="mb-2">
                                                    <p className="font-regular font-14 app-enhancements-main-content mb-0 text-wrap">
                                                        Manufacturer part number :<span className="app-enhancements-sub-content ml-2">{val.manufacturer_part_number}</span>
                                                    </p>
                                                </div>
                                                <div className="mb-2">
                                                    <p className="font-regular font-14 app-enhancements-main-content mb-0 text-wrap">
                                                        Description :<span className="app-enhancements-sub-content ml-2">{descriptionToShow}</span>
                                                        {val.long_desc.length > 24 && (
                                                            <span
                                                                className="toggle-description view-details-item cursor-pointer ml-2"
                                                                onClick={() => this.toggleDescription(val.inv_item_id)}
                                                            >
                                                                {isExpanded ? 'Less' : 'More'}
                                                            </span>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="mb-2">
                                                    <p className="font-regular font-14 app-enhancements-main-content mb-0 text-wrap">
                                                        QTY available :<span className="app-enhancements-sub-content ml-2">{val.actual_qty}</span>
                                                    </p>
                                                </div>
                                                <div className="mb-2">
                                                    <p className="font-regular font-14 app-enhancements-main-content mb-0 text-wrap">
                                                        More info:<a className="view-details-item app-enhancements-sub-content ml-2" onClick={() => this.GetMoreDetail(val)}>View details</a>
                                                    </p>
                                                </div>

                                            </div>
                                            <div className="col-lg-4 col-md-12">
                                                <div className="mb-2">
                                                    <p className="font-regular font-14 app-enhancements-main-content mb-0 text-wrap">
                                                        Manufacturer name :<span className="app-enhancements-sub-content ml-2">{val.mfg_std}</span>
                                                    </p>
                                                </div>
                                                <div className="mb-2">
                                                    <p className="font-regular font-14 app-enhancements-main-content mb-0 text-wrap">
                                                        Supplier part number :<span className="app-enhancements-sub-content ml-2">{val.supplier_part_number}</span>
                                                    </p>
                                                </div>
                                                <div className="mb-2">
                                                    <p className="font-regular font-14 app-enhancements-main-content mb-0 text-wrap">
                                                        QTY on order:<span className="app-enhancements-sub-content ml-2">{val.Qty_On_Hand || "-"}</span>
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-lg-2 col-md-12">
                                                <div className="mb-2">
                                                    <p className="font-regular font-14 app-enhancements-main-content mb-0 action-icon-res" >
                                                        Tech name :<span className="app-enhancements-sub-content ml-2">{val.employee_name}</span>
                                                    </p>
                                                </div>
                                                <div className="mb-2">
                                                    <p className="font-regular font-14 app-enhancements-main-content mb-0 action-icon-res">
                                                        Location :<span className="app-enhancements-sub-content ml-2">{truckDesc}</span>
                                                    </p>
                                                </div>
                                                <div className="mb-2">
                                                    <p className="font-regular font-14 app-enhancements-main-content mb-0 text-wrap">
                                                        Serial ID :<span className="app-enhancements-sub-content ml-2">{val.serial_id ? val.serial_id : "-"}</span>
                                                    </p>
                                                </div>

                                            </div>
                                            <div className="col-lg-2 col-md-4 d-flex justify-content-end">
                                                <div className="dropdown">
                                                    <button className="btn custom-btn-primary dropdown-toggle px-3" type="button"
                                                        id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                                        aria-expanded="false" disabled={this.state.gridData && this.state.gridData.some(item => item.checked) ? true : false}>
                                                        Actions
                                                    <img src="images/Down_Arrow.svg" alt="Custom Dropdown Icon" className="dropdown-custom-icon ml-2" />
                                                    </button>
                                                    <ul className="dropdown-menu p-0" aria-labelledby="dropdownMenuButton">
                                                        <li className={`dropdown-item dropdown-item-border font-12 cursor-pointer font-medium ${val.actual_qty === "0" ? "disabled" : ""}`}
                                                            onClick={() => val.actual_qty !== "0" && this.ActionClick('Stock Issue', val)}><img style={{ "margin-right": "10px" }}
                                                                src="images/Stock-Issue-icon.svg"
                                                                alt="" />Stock Issue</li>
                                                        <li className="dropdown-item dropdown-item-border cursor-pointer font-12 font-medium" onClick={() => this.ActionClick('Manual Stock Adjustment', val)}><img style={{ "margin-right": "12px" }}
                                                            src="images/Stock-Adjust-icon.svg"
                                                            alt="" />Stock Adjust</li>
                                                        <li className={`dropdown-item font-12 cursor-pointer font-medium ${val.actual_qty === "0" ? "disabled" : ""}`} onClick={() => val.actual_qty !== "0" && this.ActionClick('Bin-to-Bin Transfer', val)}><img className="mr-2"
                                                            src="images/Stoc-Transfer-icon.svg"
                                                            alt="" />Stock Transfer</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            });
        } else {
            return (
                <div className="">
                    <div className="col-md-12 p-2 p-0 accept-transfer-container">
                        <div className="no-record-found-section">
                            <img src="images/no-record-found.png" alt="No records found" className="no-record-found" />
                            <p className="custom-select-records font-14 mt-4">No records found</p>
                        </div>
                    </div>
                </div>
            );
        }
    }

    toggleDescription = (itemId) => {
        this.setState(prevState => {
            return {
                expandedDescriptions: {
                    ...prevState.expandedDescriptions,
                    [itemId]: !prevState.expandedDescriptions[itemId],
                }
            };
        });
    }



    handlePageClick = (e) => {
        let pageNo = e.selected + 1;
        this.setState({ PageNo: pageNo });
    };

    GetMoreDetail = (value) => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let GetMoreDetail = {
            Inv_Item_Id: value.inv_item_id,
            Region: this.state.RegionValue.value,
            Sub_Region: this.state.SubRegionValue.value,
            User_Id: value.employee_id,
        }
        FieldInventoryAction.GetMoreDetail(GetMoreDetail);
    }


    GetMoreDetailResponse = () => {
        const ParsedData = JSON.parse(FieldInventoryStore.GetMoreDetail);
        let GetMoreDetail = ParsedData.GetMoreDetail[0];



        this.setState({ GetMoreDetail });
        $('#FieldInventoryGetMoreDetail').modal('show');
        $(`#${SDIConstants.SDILoader}`).addClass('hide');


    }
    MoreDetailCloseClick = () => {
        $('#FieldInventoryGetMoreDetail').modal('hide');
        this.setState({ GetMoreDetail: [] });

    }

    ActionClick = (actionName, itemDetails) => {
        const SDIMenu = JSON.parse(localStorage.getItem("SDIMenu"));
        let hasPrivilege = false;
        let privilegeName = "";
        let navigateTo = "";



        if (actionName == 'Stock Issue') {
            hasPrivilege = true;
            navigateTo = '/STKIssuesCart';
        }
        else {
            const privilege = SDIMenu.find(item => item.ISA_IDENTIFIER_NAME === actionName);
            privilegeName = actionName.toLowerCase();
            if (privilege) {
                hasPrivilege = true;
                navigateTo = privilege.ISA_NAVIGATIONURL;
            }
        }
        let checkedItems = this.state.gridData.filter(item => item.checked); // Get checked items
        let itemsToSend = checkedItems.length > 0 ? checkedItems : [];
        if (actionName === "Bin-to-Bin Transfer" && itemDetails) {
            const itemDetailsArray = Array.isArray(itemDetails) ? itemDetails : [itemDetails];
            itemsToSend = itemDetailsArray;
        }
        if (!hasPrivilege) {
            $('#FieldInventoryprivilege').modal('show');
            this.setState({ privilege: `Insufficient privilege to view ${privilegeName}.` });
        } else {
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            this.props.history.push({
                pathname: navigateTo,
                state: {
                    ...itemDetails,
                    checkedItems: itemsToSend,
                    origin: 'FieldInventory',
                    isa_truck_id: this.state.TruckidValue.value ? this.state.TruckidValue.value : itemDetails.isa_truck_id,
                    isFromFieldInventory: true,
                    RegionDD: this.state.RegionDD,
                    SubRegionDD: this.state.SubRegionDD,
                    TruckidDD: this.state.TruckidDD,
                    TechNameDD: this.state.TechNameDD,
                    RegionValue: this.state.RegionValue,
                    SubRegionValue: this.state.SubRegionValue,
                    TruckidValue: this.state.TruckidValue,
                    TechNameValue: this.state.TechNameValue,
                    SearchTxt: this.state.SearchTxt,
                    UserId: this.state.UserId,
                    PageLoadData: this.state.PageLoadData,
                    IncludeZeroCheck: this.state.includeZeroQty,
                }
            });
        }
    };
    handleIncludeZeroQtyChange = (event) => {
        let includeZeroQty = event.target.checked;
        let totalCount = 0;
        let pageCount = 0;
        if (this.state.gridData) {
            totalCount = includeZeroQty
                ? this.state.gridData.length
                : this.state.gridData.filter(item => item.actual_qty !== '0').length;
            pageCount = parseFloat(totalCount) / 10
        }

        this.setState({ includeZeroQty: event.target.checked, totalCount, pageCount });
    };
    ClearData = () => {
        this.setState({ RegionValue: [], SubRegionValue: [], TruckidValue: [], TechNameValue: [], SearchTxt: '', UserId: [], gridData: [], includeZeroQty: false, norecordshow: false })

    }
    clearAllChecked = () => {
        this.setState(prevState => {
            const updatedGridData = prevState.gridData.map(item => ({
                ...item,
                checked: false, // Set all checked properties to false
            }));

            return {
                gridData: updatedGridData,
                selectedTruckId: ""
            };
        });
    }
    render() {



        return (
            <div>
                <div className="container-fluid container-margin content-section">
                    <div className="field-inventory-workbench-container">
                        <div className="row">
                            <div className="col-md-12 page-heading mb-3">
                                <h5 className="page-title">Field Inventory Workbench</h5>
                                <div className="fav-item-maintenance-icon mt-1">
                                    <input type="checkbox" id="checkbox-OrdStatus" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                    <label htmlFor="checkbox-OrdStatus">
                                        <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                            <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                                <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                                <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                                <g className="grp7" opacity={0} transform="translate(7 6)">
                                                    <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                    <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                                </g>
                                                <g className="grp6" opacity={0} transform="translate(0 28)">
                                                    <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                    <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                                </g>
                                                <g className="grp3" opacity={0} transform="translate(52 28)">
                                                    <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                    <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                                </g>
                                                <g className="grp2" opacity={0} transform="translate(44 6)">
                                                    <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                    <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp5" opacity={0} transform="translate(14 50)">
                                                    <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                    <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp4" opacity={0} transform="translate(35 50)">
                                                    <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                    <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp1" opacity={0} transform="translate(24)">
                                                    <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                    <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                                </g>
                                            </g>
                                        </svg>
                                    </label>
                                </div>
                            </div>

                            <div className="col-md-12">
                                <div className="w-100">
                                    <form className="form-container mt-1">
                                        <div className="form-input-container">
                                            <label className="form-label font-medium font-14" htmlFor="Region">Region<span className="color-manditory">*</span></label>
                                            <Select
                                                options={this.state.RegionDD}
                                                value={this.state.RegionValue}
                                                onChange={e => this.HandleChangeDD(e, "Region")}
                                                name="Region"
                                            />
                                        </div>

                                        <div className="form-input-container">
                                            <label className="form-label font-medium font-14" htmlFor="Subregion">Subregion <span className="color-manditory">*</span></label>
                                            <Select
                                                options={this.state.SubRegionDD}
                                                value={this.state.SubRegionValue}
                                                onChange={e => this.HandleChangeDD(e, "Subregion")}
                                                name="Subregion"
                                            />
                                        </div>

                                        <div className="form-input-container">
                                            <label className="form-label font-medium font-14" htmlFor="TruckID">Location </label>
                                            <Select
                                                options={this.state.TruckidDD}
                                                value={this.state.TruckidValue}
                                                onChange={e => this.HandleChangeDD(e, "TruckID")}
                                                name="TruckID"
                                            />
                                        </div>

                                        <div className="form-input-container">
                                            <label className="form-label font-medium font-14" htmlFor="Tech">Tech Name </label>
                                            <Select
                                                options={this.state.TechNameDD}
                                                value={this.state.TechNameValue}
                                                onChange={e => this.HandleChangeDD(e, "Tech")}
                                                name="Tech"
                                            />
                                        </div>

                                        <div className="form-input-container m-0">
                                            <label className="form-label font-medium font-14" htmlFor="search">Item search</label>
                                            <input
                                                type="text"
                                                id="search"
                                                className="form-control search-field search-width-full pr-4"
                                                placeholder="Enter item details"
                                                value={this.state.SearchTxt}
                                                onChange={(e) => this.HandleChangeDD(e, "Search")}
                                            />
                                            {this.state.SearchTxt !== undefined && this.state.SearchTxt !== null && this.state.SearchTxt !== "" && this.state.SearchTxt !== " " && this.state.SearchTxt.length > 0 && (
                                                <span className={this.state.SearchTxt.trim().length > 0 ? "search-cancel-header cursor-pointer" : "d-none"} style={{ right: "15px", top: "53px" }} onClick={() => this.Searchclear()}></span>
                                            )}
                                        </div>
                                    </form>
                                </div>

                                <div className="d-flex justify-content-end mt-5">
                                    <button className="btn custom-btn-secondary secondary-btn px-4 mr-3" disabled={!(this.state.RegionValue.value && this.state.SubRegionValue.value)} onClick={this.ClearData}>Clear</button>
                                    <button className="btn custom-btn-primary px-4 m-0" disabled={!(this.state.RegionValue.value && this.state.SubRegionValue.value)} onClick={this.GetData}>Get data</button>
                                </div>


                                <div className="w-100 d-flex justify-content-between align-items-start mt-4 mb-2">
                                    {this.state.gridData && this.state.gridData.length > 0 ? (
                                        <div className="d-flex align-items-start">
                                            <h6 className="font-16 font-medium mb-0" style={{ "margin-top": "2px" }}>
                                                Item details
                                            </h6>
                                            {this.state.gridData.filter(item => item.checked).length > 0 ? <span class="font-16 ml-2">({this.state.gridData.filter(item => item.checked).length} selected)</span> : null}
                                            {this.state.selectAll && (
                                                <p style={{ "margin-bottom": "1px" }}><button className="btn custom-btn-primary pr-2 ml-3" style={{ "margin-top": "-3px" }} onClick={() => this.handleCheckboxChange(this.state.gridData.filter(item => item.checked).length === this.state.gridData.filter(item => item.actual_qty !== '0').length ? 'Unselect All' : 'Select All')}>{this.state.gridData.filter(item => item.checked).length === this.state.gridData.filter(item => item.actual_qty !== '0').length ? 'Unselect All' : 'Select All'}</button></p>

                                            )}
                                        </div>
                                    ) : (
                                            <h6 className="font-16 font-medium"></h6>
                                        )}
                                    <div className="d-flex align-items-center">
                                        <input
                                            className="form-check-input position-unset mr-1 mt-0"
                                            type="checkbox"
                                            value=""
                                            style={{ "margin-top": "-3px" }}
                                            id="zero"
                                            checked={this.state.includeZeroQty}
                                            onChange={this.handleIncludeZeroQtyChange}
                                            disabled={!(this.state.RegionValue.value && this.state.SubRegionValue.value)}
                                        />
                                        <label className="font-14 app-enhancements-sub-content font-medium mt-1" htmlFor="zero">Include zero QTY</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="border-top pt-2" >
                        </div>
                        <div>
                            {this.state.gridData && this.state.gridData.length > 0 ? this.bindSearchResults() : this.state.norecordshow ? <div className="">
                                <div className="col-md-12 p-2 p-0 accept-transfer-container">
                                    <div className="no-record-found-section">
                                        <img src="images/no-record-found.png" alt="No records found" className="no-record-found" />
                                        <p className="custom-select-records font-14 mt-4">No inventory in this location</p>
                                    </div>
                                </div>
                            </div> : null}
                        </div>

                        {this.state.gridData && this.state.gridData.length > 0 && (
                            <div className="mt-3 d-flex justify-content-between align-items-center pb-3">
                                <label className="font-16 font-medium no-rec-color mb-0">
                                    Number of records: <span className="primary-textcolor">{this.state.totalCount}</span>
                                </label>

                                {this.state.gridData.length > 10 && (
                                    <ReactPaginate
                                        previousLabel={<span className="right-pagination-arrow" />}
                                        nextLabel={<span className="left-pagination-arrow" />}
                                        previousClassName="page-item"
                                        nextClassName="page-item"
                                        previousLinkClassName="page-link"
                                        nextLinkClassName="page-link"
                                        disabledClassName="disabled"
                                        breakLabel="..."
                                        breakClassName="page-item"
                                        breakLinkClassName="page-link"
                                        pageCount={this.state.pageCount}
                                        marginPagesDisplayed={1}
                                        pageRangeDisplayed={2}
                                        onPageChange={this.handlePageClick}
                                        containerClassName="custom-pagination pagination float-right"
                                        pageClassName="page-item"
                                        pageLinkClassName="page-link"
                                        activeClassName="active"
                                        hrefBuilder={() => '#'}
                                        forcePage={this.state.PageNo - 1}
                                    />
                                )}
                            </div>
                        )}
                        {this.state.selectedTruckId && this.state.gridData && this.state.gridData.length > 0 && this.state.gridData.some(item => item.checked) &&
                            (
                                <div className="footer-buttons d-flex justify-content-end">
                                    <button
                                        className=" btn custom-btn-secondary secondary-btn px-3 mr-3"
                                        onClick={() => this.clearAllChecked()} // Clear all checked items
                                    >
                                        Clear all
                </button>
                                    <button
                                        className="btn custom-btn-primary px-3 m-0"
                                        id="dropdownMenuButton"
                                        onClick={() => {
                                            this.ActionClick('Bin-to-Bin Transfer', '');
                                        }}
                                    >
                                        Stock Transfer
        </button>
                                </div>
                            )}


                        <div class="modal fade" id="FieldInventoryGetMoreDetail" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" data-backdrop="static" aria-hidden="true">
                            <div class="modal-dialog modal-lg custom-popup modal-dialog-centered" role="document">
                                <div class="modal-content custom-container border-0">
                                    <div class="modal-header align-items-center">
                                        <h4 class="modal-title mt-1 font-18 font-medium">More info</h4>
                                        <button type="button" class="btn py-0" data-dismiss="modal" aria-label="Close" onClick={this.MoreDetailCloseClick} >
                                            <img src="images/close-icon.svg" alt="close-icon" />
                                        </button>
                                    </div>
                                    <div class="modal-body terms-scroll py-0 pt-4 popup-info-container">
                                        <div class="row">
                                            <div class="col-md-4 col-12 mb-2">
                                                <label class="w-100 font-14 font-medium">Name</label>
                                                <span class="font-14 font-regular">{(this.state.GetMoreDetail && this.state.GetMoreDetail.ISA_USER_NAME) ? this.state.GetMoreDetail.ISA_USER_NAME : '-'}</span>
                                            </div>
                                            <div class="col-md-4 col-12 mb-2">
                                                <label class="w-100 font-14 font-medium">Email address</label>
                                                <span class="font-14 font-regular">{(this.state.GetMoreDetail && this.state.GetMoreDetail.ISA_EMPLOYEE_EMAIL) ? this.state.GetMoreDetail.ISA_EMPLOYEE_EMAIL : '-'}</span>
                                            </div>
                                            <div class="col-md-4 col-12 mb-2">
                                                <label class="w-100 font-14 font-medium">Phone</label>
                                                <span class="font-14 font-regular">{(this.state.GetMoreDetail && this.state.GetMoreDetail.PHONE_NUM) ? this.state.GetMoreDetail.PHONE_NUM : '-'}</span>
                                            </div>

                                            <div class="col-lg-12 mt-3">
                                                <div class="table-responsive mt-2">
                                                    <table class="table split-delv-table ZEUS_Grid FOM-grid mobileresponsive-grid">
                                                        <thead>
                                                            <tr>
                                                                <th class="check-table-width">BU</th>
                                                                <th class="position-sort-icon">BU description</th>
                                                                <th class="position-sort-icon text-end">Qty available</th>
                                                                <th class="position-sort-icon">Storage area</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td class="text-nowrap">{(this.state.GetMoreDetail && this.state.GetMoreDetail.BUSINESS_UNIT_IN) ? this.state.GetMoreDetail.BUSINESS_UNIT_IN : '-'}</td>
                                                                <td class="text-nowrap">{(this.state.GetMoreDetail && this.state.GetMoreDetail.BU_DESCRIPTION) ? this.state.GetMoreDetail.BU_DESCRIPTION : '-'}</td>
                                                                <td class="text-nowrap text-end">{(this.state.GetMoreDetail && this.state.GetMoreDetail.QTY_MAXIMUM) ? this.state.GetMoreDetail.QTY_MAXIMUM : '-'}</td>
                                                                <td class="text-nowrap">{(this.state.GetMoreDetail && this.state.GetMoreDetail.STORAGE_AREA) ? this.state.GetMoreDetail.STORAGE_AREA : '-'}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                            <div class="col-md-12 mb-3 mt-4 px-4">
                                                <div class="d-flex justify-content-center">
                                                    <button class="btn btn-custom-primary font-14 font-medium px-3 py-1" onClick={this.MoreDetailCloseClick}>Ok</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/*!--Modal Starts here*/}
                        <div class="modal fade alert-popup" id="FieldInventoryprivilege" tabindex="-1" role="dialog" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered custom-success-width" role="document">
                                <div class="modal-content py-2 border-0">

                                    <div class="modal-body pb-2">
                                        <div class="row">

                                            <div class="col-12 col-sm-12  col-md-12 col-lg-12 text-center">
                                                <img class="mb-3" src="images/info-icon.svg" alt="alert" />
                                                <p class="mb-1 font-14 font-regular color-light-black">{this.state.privilege} </p>
                                            </div>

                                        </div>
                                    </div>

                                    <div class="modal-footer border-0 d-flex justify-content-center pt-1">
                                        <button class="btn btn-custom-primary font-15 font-medium mr-2 mb-2 px-4 py-2" data-dismiss="modal">OK</button>
                                    </div>


                                </div>
                            </div>
                        </div>
                        {/*!--Modal ends here*/}



                    </div>
                </div>
            </div>






        );


    }








}

export default withTranslation()(FieldInventoryComponent);